import { render, staticRenderFns } from "./GeneralUserInfoTable.vue?vue&type=template&id=153f68d8&scoped=true"
import script from "./GeneralUserInfoTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralUserInfoTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GeneralUserInfoTable.vue?vue&type=style&index=0&id=153f68d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f68d8",
  null
  
)

export default component.exports